module.exports = __webpack_public_path__ + "static/img/8.b5cb42d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/8.png
// module id = RZis
// module chunks = 0